import axios from 'axios';

// API Configuration
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  UPLOAD_BASE: process.env.REACT_APP_API_BASE_URL 
    ? `${process.env.REACT_APP_API_BASE_URL}/api/v1/upload`
    : '/api/v1/upload',
  TIMEOUT: 30000, // 30 seconds
};

// Create axios instance with common configuration
const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
    console.error('API Response Error:', errorMessage);
    
    // Handle specific error codes
    if (error.response?.status === 401) {
      // Handle unauthorized access
      console.warn('Unauthorized access detected');
    } else if (error.response?.status >= 500) {
      // Handle server errors
      console.error('Server error detected');
    }
    
    return Promise.reject(new Error(errorMessage));
  }
);

// Utility function to create FormData requests
const createFormDataRequest = (url, data, options = {}) => {
  return apiClient({
    ...options,
    url,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options.headers,
    },
  });
};

export { 
  apiClient, 
  API_CONFIG, 
  createFormDataRequest 
};